module.exports = __webpack_public_path__ + "img/avatar.1463bfb0.png";